import React from "react";
import { useNavigate } from "react-router-dom";
import "../css/OurApproach.css";

const OurApproach = () => {
  const navigate = useNavigate();

  const openVisionMission = () => {
    navigate("/vision-mission");
  };

  return (
    <section className="our-approach">
      <div className="our-approach-container">
        {}
        <div className="our-left">
          <div className="orbit-wrapper">
            {}

            <div className="orbit orbit-one"></div>
            <div className="orbit orbit-two"></div>
            <div className="orbit orbit-three"></div>

            {}

            <div className="center-school">
              <img
                src="https://images.unsplash.com/photo-1580582932707-520aed937b7b?auto=format&fit=crop&w=900&q=80"
                alt="School"
              />
            </div>

            {}

            <div className="student student-one">
              <img
                src="https://images.unsplash.com/photo-1503676260728-1c00da094a0b?auto=format&fit=crop&w=500&q=80"
                alt=""
              />
            </div>

            {}

            <div className="student student-two">
              <img
                src="https://images.unsplash.com/photo-1544717305-2782549b5136?auto=format&fit=crop&w=500&q=80"
                alt=""
              />
            </div>

            {}

            <div className="student student-three">
              <img
                src="https://images.unsplash.com/photo-1513258496099-48168024aec0?auto=format&fit=crop&w=500&q=80"
                alt=""
              />
            </div>

            {}

            <div className="student student-four">
              <img
                src="https://images.unsplash.com/photo-1529390079861-591de354faf5?auto=format&fit=crop&w=500&q=80"
                alt=""
              />
            </div>

            {}

            <span className="dot blue big"></span>

            <span className="dot orange"></span>

            <span className="dot green"></span>

            <span className="dot red"></span>

            <span className="dot navy"></span>
          </div>
        </div>

        {}

        <div className="our-right">
          <h2>Outstanding Global Community</h2>

          <p>
            Students from different communities and backgrounds become part of
            the vibrant Sahara Public School family. They learn teamwork,
            collaboration, respect, empathy, leadership and communication while
            interacting with classmates from diverse cultures.
          </p>

          <p>
            We nurture students with knowledge, confidence and strong moral
            values so they grow into responsible citizens ready to succeed in
            academics and beyond.
          </p>
        </div>
      </div>
      {}

      <div className="shape-plus">+</div>

      <div className="shape-circle"></div>

      <div className="shape-triangle"></div>

      <div className="shape-square"></div>
    </section>
  );
};

export default OurApproach;
